import { useFormFactory } from '@meilleurtaux/form-factory'
import { Header as HeaderDS, MobileMenu, useDeviceDetection } from '@meilleurtaux/form-factory-ds'
import { memo, useCallback, useMemo, useState } from 'react'
import SaveAndContinueLater from './SaveAndContinueLater'
import type { Step } from '@meilleurtaux/form-factory'
import { showTopProgressBar } from 'utils/stepperLayout'
import { getUrl } from 'utils/url'

const Header = memo(function Header({
  argumentMarketing,
}: Readonly<{ argumentMarketing?: string }>) {
  const { currentSlide, stepper, appearance, goPrev, goTo, canPrev, progress } = useFormFactory(
    import.meta.env.VITE_API_URL,
  )

  const device = useDeviceDetection()
  const compact = device === 'Desktop' && showTopProgressBar(appearance.stepperPosition)

  const [menuOpened, setMenuOpened] = useState(false)
  const [saveModalOpened, setSaveModalOpened] = useState(false)

  const closeMenu = useCallback(() => {
    setMenuOpened(false)
    setSaveModalOpened(false)
  }, [])

  const handleClickEvent = useCallback(
    (step: Step) => {
      if (step.state !== 'validated' && step.state !== 'paused') return () => {}
      return () => {
        goTo(step)
        closeMenu()
      }
    },
    [goTo, closeMenu],
  )

  const stepperContent = useMemo(
    () => ({
      stepperItems: stepper,
      progress: progress.percent,
      handleClickEvent: (step: Step) => handleClickEvent(step)(),
    }),
    [stepper, progress.percent, handleClickEvent],
  )

  const handleSaveForLater = useCallback(() => setSaveModalOpened(true), [])
  const handleSaveModalClose = useCallback(() => setSaveModalOpened(false), [])

  return (
    <>
      <HeaderDS
        canPrev={canPrev}
        compact={compact}
        goPrev={goPrev}
        redirection={getUrl(import.meta.env.VITE_ENV, 'home', appearance)}
        argumentMarketing={argumentMarketing}
        saveForLaterDisabled={(currentSlide?.id ?? 1) <= 1}
        saveForLaterOnClick={handleSaveForLater}
      />
      {menuOpened && (
        <MobileMenu
          onClose={closeMenu}
          onSave={handleSaveForLater}
          stepperContent={stepperContent}
        />
      )}
      <SaveAndContinueLater open={saveModalOpened} onClose={handleSaveModalClose} />
    </>
  )
})

Header.displayName = 'Header'

export default Header
